import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  size?: 'lg' | 'md' | 'sm';
  defaultValue?: string;
  placeholder?: string;
  className?: string;
}

export default function SearchBar({
  size = 'md',
  defaultValue = '',
  placeholder = '搜索日韩电影、电视剧、综艺或标签',
  className = '',
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const sizeClasses =
    size === 'lg'
      ? 'h-14 pl-5 pr-2 text-base'
      : size === 'sm'
      ? 'h-10 pl-4 pr-1.5 text-sm'
      : 'h-12 pl-4 pr-1.5 text-sm';

  const buttonSize =
    size === 'lg' ? 'h-10 w-24 text-sm' : size === 'sm' ? 'h-7 w-8' : 'h-9 w-20 text-sm';

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className={`flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 p-1.5 ${className}`}
    >
      <i
        className={`ri-search-line shrink-0 text-foreground-400 ${
          size === 'lg' ? 'ml-3 text-xl' : size === 'sm' ? 'ml-2 text-base' : 'ml-2.5 text-lg'
        }`}
      ></i>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视作品"
        className={`min-w-0 flex-1 bg-transparent text-foreground-900 placeholder:text-foreground-400 focus:outline-none ${sizeClasses}`}
      />
      <button
        type="submit"
        aria-label="搜索"
        className={`shrink-0 whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer ${buttonSize}`}
      >
        {size === 'sm' ? <i className="ri-search-line"></i> : '搜索'}
      </button>
    </form>
  );
}